import React from 'react';

const contact = () => {
    return (
        <section id="contact">
            <div className="row">
                <div className="" >
                    <h2 style={{ color: "#ffffff" }}><i className="fa fa-envelope" /></h2>
                    <h4>Contact Info</h4>
                    <p className="address" style={{color: '#ffffff'}}>
                        Luke Simonetti<br />
                        <a href="mailto:lukejsimonetti@gmail.com">lukejsimonetti@gmail.com</a><br />
                        <span style={{color: '#ffffff'}}>770.875.8861</span>
                    </p>
                    <h4 className="widget-title">Latest Work</h4>
                    <ul>
                        <li>
                            <p style={{color: '#ffffff'}}>
                                Please download my resume from above for more details about my experience.
                                I have added a few repositories on my <a href="https://github.com/lukejsimonetti">GitHub profile</a> that illustrate some of the proprietary code I’ve written.
                                Due to the nature of the projects, I cannot display the entire repository.
                                I’d be happy to display the rest of the code in an interview.
                                </p>
                        </li>
                    </ul>
                </div>
            </div>
            {/* <div className="row">
                <div className="eight columns">
                    <form method="post" id="contactForm" name="contactForm">
                        <fieldset>
                            <div>
                                <label htmlFor="contactName">Name <span className="required">*</span></label>
                                <input type="text" defaultValue size={35} id="contactName" name="contactName" />
                            </div>
                            <div>
                                <label htmlFor="contactEmail">Email <span className="required">*</span></label>
                                <input type="text" defaultValue size={35} id="contactEmail" name="contactEmail" />
                            </div>
                            <div>
                                <label htmlFor="contactSubject">Subject</label>
                                <input type="text" defaultValue size={35} id="contactSubject" name="contactSubject" />
                            </div>
                            <div>
                                <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                                <textarea cols={50} rows={15} id="contactMessage" name="contactMessage" defaultValue={""} />
                            </div>
                            <div>
                                <button className="submit">Submit</button>
                                <span id="image-loader">
                                    <img src="images/loader.gif" />
                                </span>
                            </div>
                        </fieldset>
                    </form> 
                    <div id="message-warning"> Error boy</div>
                    <div id="message-success">
                        <i className="fa fa-check" />Your message was sent, thank you!<br />
                    </div>
                </div>
                <aside className="four columns footer-widgets">
                    <div className="widget widget_contact">
                        <h4>Contact Info</h4>
                        <p className="address">
                            Luke Simonetti<br />
                            <a href="mailto:lukejsimonetti@gmail.com">lukejsimonetti@gmail.com</a><br />
                            <span>770.875.8861</span>
                        </p>
                    </div>
                    <div className="widget widget_tweets">
                        <h4 className="widget-title">Latest Work</h4>
                        <ul id="twitter">
                            <li>
                                <span>
                                Please download my resume from above for more details about my experience. 
                                I have added a few repositories on my GitHub profile that illustrate some of the proprietary code I’ve written. 
                                Due to the nature of the projects, I cannot display the entire repository. 
                                I’d be happy to display the rest of the code in an interview.
                                </span>
                            </li>
                        </ul>
                    </div>
                </aside>
            </div> */}
        </section>


    )
}

export default contact


// WEBPACK FOOTER //
// ./src/main/contact.js